let tabContent , firstTabContent , tab , tabItem , accordianTitle;
function onDocumentReady(){
    tabContent = $(".tab-content");
    firstTabContent = $(".tab-content").first();
    tab = $(".tabs");
    tabItem = tab.find(".tab");
    accordianTitle = $(".accorian-title");
    tabItem.first().addClass('active');
    tabContent.hide();
    firstTabContent.show();

 /* if in tab mode */
    tabItem.click(function() {
        var activeTab = $(this).attr("rel");
        tabContent.hide();

        $("#"+activeTab).fadeIn();

        tabItem.removeClass("active");
        $(this).addClass("active");

        accordianTitle.removeClass("accorian-active");
        $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("accorian-active");

    });
    /* if in drawer mode */
    accordianTitle.click(function() {
        tabContent.hide();
        var activeAccordian = $(this).attr("rel");
        $("#"+activeAccordian).fadeIn();

        accordianTitle.removeClass("accorian-active");
        $(this).addClass("accorian-active");

        tabItem.removeClass("active");
        $("ul.tabs li[rel^='"+activeAccordian+"']").addClass("active");

        $('html, body').animate({
            scrollTop: $(this).closest('.tab-container').offset().top
        }, 500);

    });

}
document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/tab-controller.js